import React, { useState, useRef, useEffect } from "react";
import classNames from 'classnames';

import Horizontal from './templates/Horizontal';
import Vertical from './templates/Vertical';
import None from './templates/None';

const Item = (props) => {

  const { id, select, template, active } = props;

  const Klass = classNames(
    'import-rss__item',
    {
      'import-rss__item--selected': active(id)
    }
  )

  const handleClick = (e) => {
    e.preventDefault();
    return false;
  }

  const Component = {
    horizontal: Horizontal,
    vertical: Vertical,
    none: None
  }[template];

  return (
    <div className={Klass} data-id={id} onSelect={select} onClick={handleClick}>
      <Component {...props} />
    </div>
  )
}

export default Item;
